import { inject, injectable } from "inversify";
import { SessionDto, ServiceResponse, AddressDto, AddressSearchResultsDto, IPlatformClient, IPlatformClientId } from "@se/platform";
import { IAddressLookupService } from "../";

@injectable()
class AddressLookupService implements IAddressLookupService {
    
    constructor(
        @inject(IPlatformClientId) private platformClient: IPlatformClient) {
    }

    public async searchAddresses(session: SessionDto, searchTerm: string) : Promise<ServiceResponse<AddressSearchResultsDto>> {

        const response = await this.platformClient.lookups.searchAddressesAsync(searchTerm, "GB", session.accessToken);
        return response;
    }
    
    public async getAddress(session: SessionDto, addressId: string) : Promise<ServiceResponse<AddressDto>> {

        const response = await this.platformClient.lookups.getAddressById(addressId, session.accessToken);
        return response;
    }
};

export { AddressLookupService }